definitionNode